export default {
  'moduleTitle.address': 'ठेगाना',
  'moduleTitle.address_details': 'पुरा ठेगाना',
  'moduleTitle.activity_details': 'क्रियाकलापको विस्तृत विवरण',
  'moduleTitle.add_log': 'लग थप्नुहोस',
  'moduleTitle.award_level': 'अवार्डको तह',
  'moduleTitle.adventurous_journey': 'साहसिक यात्रा',
  'moduleTitle.already_assessed': 'प्रमाणित भै सक्यो',
  'moduleTitle.approved': 'स्वीकृत भयो !',
  'moduleTitle.assessor_details': 'निरिक्षकको विवरण',
  'moduleTitle.authorising_contact_license_holder': 'आधिकारिक सम्पर्क नम्बर / लाइसेन्स प्राप्त ब्यक्ति',
  'moduleTitle.category_journey_details': '\n{category} यात्राको विवरण',
  'moduleTitle.complete_report': 'पूर्ण रिपोर्ट',
  'moduleTitle.completed_progress': 'पुरा भयको {finished} / {total}',
  'moduleTitle.congratulation': 'बधाई !',
  'moduleTitle.confirming_email_address': 'इमेल ठेगाना कन्फर्म गर्दै ......',
  'moduleTitle.contact_details': 'सम्पर्क विवरण',
  'moduleTitle.edit_log': 'लग सम्पादन',
  'moduleTitle.event_journey': '{event} यात्रा',
  'moduleTitle.forgotten_password': 'पासवर्ड बिर्सियो',
  'moduleTitle.great_you_are_almost_there': 'धेरै रामो अब सकिनै लाग्यो ,अब नयाँ लेवलका लागि दस्तुर तिर्नुहोस ।',
  'moduleTitle.home_address': 'घरको ठेगाना',
  'moduleTitle.journey_overview': 'यात्राको विवरण',
  'moduleTitle.log_detail': 'लग विवरणहरु',
  'moduleTitle.login': 'लग इन',
  'moduleTitle.new_activity': 'नयाँ क्रियाकलाप',
  'moduleTitle.new_event_journey': 'नयाँ {event} यात्रा',
  'moduleTitle.new_residential_project': 'नयाँ आबासिय परियोजना',
  'moduleTitle.notRegistred': 'दर्ता गर्नुभएको छैन ?',
  'moduleTitle.nominated_award_leader_contact_details': 'मनोनित अवार्ड लिडरको सम्पर्क ठेगाना',
  'moduleTitle.nominated_award_leader': 'मनोनित अवार्ड लिडर',
  'moduleTitle.organisation_address': 'संस्थाको ठेगाना',
  'moduleTitle.organisation_details': 'संस्थाको विस्तृत विवरण',
  'moduleTitle.online_record_book_account': 'अनलाईन रेकर्ड बुक खाता',
  'moduleTitle.page_not_found': '४०४- पेज भेट्न सकिएन',
  'moduleTitle.personal_details': 'व्यक्तिगत विवरण',
  'moduleTitle.preparation_and_training': 'तयारी र तालिम',
  'moduleTitle.profile_guardian_consent': 'अभिभाबक/ संरक्षककको सहमति',
  'moduleTitle.profile_questions': 'प्रोफाइल प्रश्नहरु',
  'moduleTitle.registration_for_level': 'नयाँ तहको लागि दर्ता',
  'moduleTitle.residential_project': 'आबासिय परियोजना',
  'moduleTitle.residential_project_details': 'आबासिय परियोजनाको विवरण',
  'moduleTitle.reset_password': 'पासवोर्ड परिबर्तन गर्नुहोस',
  'moduleTitle.welcome_to_the_orb': 'अनलाइन रेकर्ड बुकमा स्वागत छ ',
  'moduleTitle.we_have_sent_you_an_email': 'तपाईलाई सेवा सुचारु गर्ने लिन्क सहितको इमेल पठाईएको छ ।',
  'moduleTitle.your_registration_is_complete': 'तपाइको दर्ता प्रकिया पुरा भयो ।',
  'formTitle.activity_details': 'क्रियाकलाप विवरण',
  'formTitle.assessor_details': 'निरिक्षकको बिबरण',
  'formTitle.supervisors_details': 'पर्यबेक्षको विवरण',
  'formTitle.preparation_and_training_activities': 'तयारी तथा तालिम गतिविधिहरू',
  'formTitle.added_preparation_activities': 'तयारी तथा तालिमको क्रियाकलापहरु थपियो ।',
  'label.add_picture': 'चित्र राख्नुहोस ।',
  'label.address_first_line': 'ठेगाना पहिलो लाइन',
  'label.address_second_line': 'ठेगाना दोश्रो लाइनमा  ( अनिबार्य छैन )',
  'label.are_you_already_running_award': 'के तपाईंले पहिलेनै अवार्ड प्रयोगगर्नु  भएको छ ?',
  'label.are_you_the_main_award_leader': 'के तपाईं अवार्ड युनिट को मुख्य अवार्ड लिडर वा कोअर्डिनेटर हो ?',
  'label.award_participant': 'अवार्ड सहभागी',
  'label.award_leader': 'अवार्ड लिडर',
  'label.birthdate': 'जन्ममिति',
  'label.category': 'खण्ड',
  'label.change_locale': 'स्थान परिबर्तन गर्नुहोस ।',
  'label.choose_project': 'क्रियाकलाप छनोट गर्नु होस ।',
  'label.city': 'सहर',
  'label.choose_as_major_activity': 'मुख्य क्रियाकलाप छनोट गर्नुहोस ।',
  'label.date': 'मिति',
  'label.date_of_birth': 'जन्ममिति',
  'label.description_of_progress': 'प्रगति विवरण',
  'label.duration': 'अबधि (मिनेट)',
  'label.email': 'इमेल',
  'label.email_address': 'इमेल ठेगाना',
  'label.email_again': 'इमेल ठेगाना पुष्टि गर्नुहोस ।',
  'label.employment_status': 'रोजगारीको अवस्था',
  'label.end_date': 'अन्त्य मिति',
  'label.enter_his_email': 'इमेल उल्लेख गर्नुहोस।',
  'label.entered_transaction_id': 'तपाइको कारोबार आइडी',
  'label.first_name': 'पहिलो नाम',
  'label.gender': 'लिङ्ग',
  'label.goal': 'लक्ष',
  'label.journey_activity': 'यात्राका क्रियाकलाप',
  'label.journey_objective': 'यात्राको लक्ष',
  'label.journey_observations': 'यात्रा अबलोकन/अनुभब',
  'label.journey_type': 'यात्राको प्रकार',
  'label.last_name': 'अन्तिम नाम',
  'label.level': 'तह',
  'label.location': 'स्थान',
  'label.logout': 'लगआउट',
  'label.major': 'मुख्य',
  'label.middle_name': 'बिचको नाम',
  'label.mode_of_transport': 'यातायातको किसिम',
  'label.my_award_leader': 'मेरो अवार्ड लिडर',
  'label.name': 'नाम',
  'label.nationality': 'राष्ट्रियता',
  'label.no': 'होइन',
  'label.no_results': 'नतिजा भेटिएन ।',
  'label.note': 'नोट',
  'label.note_for_assessor': 'निरीक्षकको लागि नोट',
  'label.note_for_leader': 'लिडरको लागि नोट',
  'label.optional': 'बैकल्पिक',
  'label.organisation_name': 'सस्थाको नाम',
  'label.organisation_type': 'सस्थाको प्रकार',
  'label.others': 'अन्य',
  'label.password': 'पासवोर्ड',
  'label.password_again': 'पासवोर्ड दोहोर्याउनुहोस',
  'label.project_location': 'परियोजनाको स्थान',
  'label.pay_online': 'अनालाइन भुक्तानी गर्नुहोस ।',
  'label.pay_award_leader_or_unit': 'अवार्ड लिडर वा इकाईलाई भुक्तानी दिनुहोस ।',
  'label.payment_not_required': 'सहभागीले भुक्तानी गर्न आबस्यक छैन ।',
  'label.payment_type': 'भुक्तानीको किसिम',
  'label.phone': 'फोन',
  'label.phone_number': 'फोन नम्बर',
  'label.phone_type': 'फोनको प्रकार',
  'label.profile': 'प्रोफाइल',
  'label.reset_password': 'पासवोर्ड परिबर्तन गर्नुहोस ।',
  'label.region': 'प्रदेश/ क्षेत्र',
  'label.relationship': 'सम्बन्ध',
  'label.role_in_organisation': 'संस्थामा भूमिका',
  'label.select_country': 'देश चयन गर्नुहोस ।',
  'label.select_your_au': 'अवार्ड इकाई चयन गर्नुहोस ।',
  'label.start_typing': 'लेख्न सुरु गर्नुहोस',
  'label.start_date': 'सुरु मिति',
  'label.select': 'छान्नुहोस्',
  'label.select_async': 'लेख्नन सुरु गर्नुहोस .....',
  'label.select_your_operating_authority': 'तपाईंको अपरेटिङ अथोरिटी छान्नुहोस् ।',
  'label.specify_category': 'कृपया तपाईंको वर्ग छुट्याउनु होस् ।',
  'label.subcategory': 'थप बिभाग',
  'label.title': 'शिर्षक',
  'label.username': 'प्रयोगकर्ता नाम',
  'label.what_is_your_role': 'संस्थामा तपाइको भूमिका के हो ?',
  'label.where_have_you_completed': 'तपाईले कहाँबाट पुरा गर्नुभयो ?',
  'label.yes': 'हो',
  'label.your_changes_havent_been_saved': 'तपाईंलेगर्नु भएको परिबर्तन सुरक्षित भएन, तथ्यहरु मेटिन सक्नेछन ।',
  'label.zip': 'जिप / पोस्ट कोड',
  'label.adventurous_journey': 'साहासिक यात्रा',
  'label.after_your_journey_describe': 'केही वाक्यमा आफ्नो साहसिक यात्राको अवलोकन वर्णन गर्नुहोस ।',
  'label.because_your_age_is_under_18': 'किनकि तपाइँ १८ बर्ष मुनिको हुनुहुन्छ,हामीलाई तपाईंको  अभिभावकको सहमति आवस्यक छ ।',
  'label.before_you_head_to_journey': 'साहसिक यात्रा सुरु गर्नु पूर्व तपाईंले तयारी र तालिम पुरा गर्नु पर्ने छ ।',
  'label.before_entering_new_level': 'अर्को तहमा प्रवेश गर्नुपूर्व सम्पूर्ण व्यक्तिगत विवरण उल्लेख गर्नुहोस ।',
  'label.bring_required_amount_to_your_award_leader': 'तोकिएको रकम  ल्याएर आफ्नो अवार्ड लिडरलाई बुझाउनु होस् ।',
  'label.do_you_have_any_other_level': 'के तपाइले यो भन्दा अधिल्ला अवार्ड तह पुरा गर्नु भएको छ ?',
  'label.do_you_know_who_is_your_award_leader': 'तपाइको अवार्ड लिडर को हो , के तपाईंलाई थाहा छ ?',
  'label.going_on_an_expedition': 'सहासिक यात्राले तपाईंलाई समूह मा काम गर्ने साथै आफै नयाँ काम गर्ने अबसर प्रदान गर्दछ  ।',
  'label.going_on_residential_gives_chance': 'आबासिय परीयोजना पुरा गर्नाले तपाईंलाई विभिन्न परिबेसका मानिसहरुसंग काम गर्न सिकाउछ र नया बाताबरणमा घुलमिल हुन आत्मविश्वास बढउछ ।',
  'label.i_confirm_that_i_meet': 'मैले सबै NAO का नीति नियमहरु पुरा गरेको निश्चित गर्न चहान्छु ।',
  'label.i_agree_to_volunteer_code': 'म स्वय सेवकको नियम मान्न तयार छु । थप जानकारीको लागि क्लिक गर्नुहोस ।',
  'label.i_have_read_the_terms_and_conditions': 'मैले मूल्य र मान्यताहरु पढे , मान्न तयार छु ।',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'म मेरो अवार्ड लिडर बाट पछी सहमति ल्याउन चाहन्छु ।',
  'label.if_you_are_from_orphanage': 'उदाहरणकालागि तपाईं को बिधालय वा संस्थाले तपाईं को पैसा तिरी दिन सक्छ ।',
  'label.here_you_can_add_activity': 'यहाँ तपाइले अन्य  तयारी र तालिमका क्रियाकलाप थप्न सक्नु हुन्छ ।',
  'label.how_do_you_want_to_apply': 'के तपाइँ निबेदन दिन चाहनुहुन्छ ?',
  'label.my_parent_consent_has_been_already_given': 'मेरो अभिभाबकको स्वीकृति मैले पहिलेनै अवार्ड लिडरलाई बुझाइसके ।',
  'label.my_parent_will_confirm_consent_by_email': 'मेरा अभिभावकले इमेल मार्फत सहमति प्रदान गर्नु हुनेछ  ।',
  'label.major_activity_means_that_you_have_to_spent': 'प्रमुख क्रियाकलाप भन्नाले अन्य क्रियाकलाप भन्दा यो क्रियाकलापको लागि थप समय खर्चिनुपर्नेछ ।',
  'label.not_sure_about_your_auth': 'एदी तपाईं कुन अवार्ड अथोरिटी बाट रजिस्टर गर्ने भन्ने ठेगान छैन भने कृपया रिजनल अफिस मा सम्पर्क गर्नु होला ।',
  'label.page_not_found': '४०४- पेज भेटिएन',
  'label.please_fill_in_the_following': 'तपाईं को ओर्गनाईजेसनको लागि  मन्न्यताप्रप्त सम्पर्क नम्बर वा लाइसेन्स लिने ब्यक्तिको विवरण तल उल्लेख गर्नुहोस ।',
  'label.register_a_new_account_as': 'यसरि नयाँ खाता दर्ता गर्नुहोस;',
  'label.residential_project': 'आबासिय परियोजना',
  'label.select_your_award_unit': 'अवार्ड इकाई चयन गर्नुहोस',
  'label.the_expedition_can_be_faraway': 'तपाईं को सहासिक यात्रा तपाईंको घर बाट नजिक वा टाढा हुन सक्छ । तपाईं ले सयौ तरिका रोज्न सक्नु हुन्छ ।',
  'label.to_log_your_process_on_orb': 'अनलाईन रेकर्ड बुकमा खाता खोल्ने प्रकिया पुरा गर्नका लागि पासवोर्ड तय गर्नुहोस ।',
  'label.waiting_for_assessment': 'मूल्यांकनको पर्खाइमा ।',
  'label.waiting_for_sign_off': 'अवार्ड लिडरको साइन अफको पर्खाइमा ।',
  'label.we_have_sent_you_an_email': 'सुचारु गर्ने लिंक सहित हामीले यहालाई इमेल पठाएका छौ ।',
  'label.what_level_of_the_award': 'कुन तहको अवार्डको लागि दर्ता गर्दै हुनुहुन्छ ?',
  'label.you_are_now_registering_as_participant': 'अवार्ड  सहभागीको रुपमा यहाँ दर्ता हुनु भयको छ ।',
  'label.you_are_now_registering_as_award_unit': 'अवार्ड इकाईको रुपमा यहाँ दर्ता हुनु भएको छ ।',
  'label.you_can_use_my_photos_for_promotional_purposes': 'एउटा सहभागी को रुपमा म मेरो चित्रहरु फोटोहरु फाउन्डेसन लाई अवार्ड प्रचार प्रसार गर्न आनुमति दिन्छु ।',
  'label.you_can_send_activity_for_approval': 'अब तपाइले आफ्नो क्रियाकलाप स्वीकृतिको लागि निरिक्षकलाई पठाउन सक्नु हुनेछ  ।',
  'label.you_can_send_activity_for_leader': 'अब तपाइले आफ्नो क्रियाकलाप स्वीकृतिको लागि अवार्ड लिडरलाई पठाउन सक्नु हुने छ  ',
  'label.you_can_send_residential_project_to_leader': 'अब तपाइले आफ्नो आबासिय परियोजना  स्वीकृतिको लागि अवार्ड लिडरलाई पठाउन सक्नु हुने छ ।',
  'label.you_have_finished_now_send_to_approval': 'तपाइको क्रियाकलाप सकियो, अब तपाइले स्वीकृतिको लागि निरिक्षकलाई बुझाउन सक्नु हुनेछ साथै तल केहि लेखन सक्नु हुने छ ।',
  'label.preparation_and_training': 'तयारी र तालिम',
  'label.you_will_be_redirected_to_the_payment': 'तपाईं लाई पैसा तिर्ने तरिका तिर लगिदैछ जहाँ तपाईंले क्रेडिट कार्ड र डेबिट कार्ड बाट तिर्न सक्नुहुन्छ',
  'label.you_will_be_the_first_award_leader': 'तपाई सस्थाको पहिलो अवार्ड लिडर बन्दै हुनुहुन्छ, तपाईसंग अवार्ड लिडरहरु र सहभागीहरु थप्ने साथै अनलाइन रेकर्ड बुक मार्फत सो को प्रकिया मिलाउने अधिकार हुनेछ ।',
  'label.youll_receive_a_notification': 'तपाईं को अवार्ड लिडर ले तपाईं को रजिस्ट्रेसन स्वीकार गरेपछि तपाईं ले सूचना पाउनु हुन्छ । त्यसपछि तपाईं ORB <a>here</a>  लग इन गर्न सक्नु हुन्छ । (जब सम्म तपाईं को अवार्ड लिडर ले स्वीकार गर्नुहुन्न तपाईं ले सिमित आधिकार मात्र प्राप्त गर्नुहुन्छ) ।',
  'label.your_parent_email': 'अभिभावाकको इमेल',
  'label.your_parent_first_name': 'अभिभावकको पहिलो नाम',
  'label.your_parent_last_name': 'अभिभाबककोअन्तिम नाम',
  'label.your_report_approve_now_send_to_leader': 'तपाइको प्रगति विवरण  निरिक्षक  द्वारा स्वीकृत गरिएको छ। अब तपाईं अनुमोदनको लागि आफ्नो अवार्ड लिडरलाई पेस गर्न सक्नुहुन्छ। तपाईं पनि तल व्यक्तिगत टिप्पणी थप्न सक्नुहुन्छ।',
  'label.there_are_loads_of_exciting_possibilities': 'तपाईं संग धेरै सम्भावना र अवसर हरु छन् । तेस्तो छान्नुहोस् जसले तपाईंको चाहना पुरा गरोस ।',
  'label.your_residential_project_has_been_setup': 'तपाइको आबासिय परियोजना तयार भै स्वीकृतिकोलागि अवार्ड लिडरलाई पठाईएको छ ।',
  'label.your_report_has_been_sent_assessor': 'तपाइको प्रगति विवरण स्वीकृतिको लागि निरीक्षकलाई पठाईएको छ।',
  'label.your_report_has_been_sent_leader': 'तपाइको प्रगति विवरण स्वीकृतिको लागि अवार्ड लिडरलाई पठाईएको छ ।',
  'label.your_residential_project_is_complete': 'तपाइको आबासिय परियोजना पुरा भएको छ।',
  'label.to_work_on_the_online': 'अनलाइन रेकर्ड बुक (ORB) मा काम गर्न तपाईं संग ब्यक्तिगत खाता हुनु जरुरि छ ।',
  'label.we_will_send_you_an_email': 'तपाईं को ORB रजिस्ट्रेसन स्वीकार भएपछी हामी तपाईंलाई इमेल पठाउछौ ।',
  'label.if_you_have_any_problems_or_doubts': 'यदि यहालाई केहि समस्या वा जिज्ञासा छ भने अवार्ड इकाईमा सम्पर्क गर्न सक्नु हुन्छ ।',
  'label.are_you_sure_you_want_to_leave': 'के तपाइँ साच्चै बाहिरिन चाहनुहुन्छ ? सबै तथ्य मेटिने छन ।',
  'label.no_logs_yet': 'अहिले सम्म कुनै लग लेखिएको छैन / <br /> लग थप्नुहोस बटन दबाएर तपाईं को पहिले लग लेख्नुहोस ।',
  'label.menu': 'मेनु',
  'notifications.award_unit_has_been_created': 'अवार्ड इकाई सिर्जना गरिएको छ ।',
  'notifications.authorization_code_is_not_valid': 'आधिकारिक  कोड मान्य भएन।',
  'notifications.email_has_been_confirmed': 'इमेल ठेगाना पुष्टि भयको छ ।',
  'notifications.leader_has_been_created': 'लिडरलाई सामेल गरिएको छ ।',
  'notifications.participant_has_been_created': 'सभागीलाई सामेल गरिएको छ ।',
  'notifications.email_with_instructions_has_been_sent': 'प्रकिया सहितको इमेल पठाइसकिएको  छ ।',
  'notifications.your_new_password_has_been_set': 'तपाइको नया पासवोर्ड सेट भएको छ ।',
  'notifications.success': 'सफलता',
  'notifications.unknown_role': 'थाहा नभएको भूमिका',
  'notifications.waiting_for_approval': 'स्वीकृतिको पर्खाइमा ....',
  'notifications.activity_cannot_be_created': 'दर्ता स्विकृत नभएसम्म क्रियाकलाप सिर्जना गर्न सकिदैन ।',
  'notifications.new_activity_has_been_added': 'नयाँ  क्रियाकलाप थापियो ।',
  'notifications.new_log_has_been_added': 'नयाँ  लग थापियो ।',
  'notifications.log_has_been_deleted': 'लग हटाइयो ।',
  'notifications.log_has_been_modified': 'लग संशोधन गरियो ।',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'दर्ता स्विकृत नभएसम्म साहसिक यात्रा  सिर्जना गर्न सकिदैन ।',
  'notifications.new_participant_event_has_been_added': 'नया इभेन्ट थापिएको  छ।',
  'notifications.participant_event_has_been_completed': 'सहभागीको इभेन्ट  पुरा भएको छ ।',
  'notifications.training_and_practice_modified': 'तयारि र तालिम संसोधन भएको छ ।',
  'notifications.completion_residential_project_completed': 'आबासिय परियोजना पुरा भयो ।',
  'notifications.new_residential_project_has_been_added': 'नया आबासिय परियोजना थपियो ।',
  'notifications.residential_project_cannot_be_created_until_approved': 'दर्ता स्विकृत नभएसम्म आबासिय परियोजना सिर्जना गर्न सकिदैन ।',
  'notifications.already_assessed_sent': 'लिडर स्वीकृतिको अनुरोध पठाइयो ।',
  'notifications.assessment_request_sent': 'मुल्यांकनका लागि आनुरोध पठाइसकेको छ ।',
  'notifications.leader_approval_sent': 'लिडरबाट प्रमाणिकरणका लागि पठाइएको छ ।',
  'tabs.logs': 'लगहरु',
  'tabs.new': 'नया',
  'tabs.overview': 'सिंहावलोकन',
  'tabs.report': 'रिपोर्ट',
  'button.add_activity': 'क्रियाकलाप थप्नुहोस ।',
  'button.add_log': 'लग थप्नुहोस।',
  'button.continue_here': 'यहाँ बाट निरन्तरता दिनुहोस',
  'button.continue': 'जारी राख्न',
  'button.continue_to_award': 'अवार्ड निरन्तर गर्नुहोस ।',
  'button.delete': 'मेटाउनु होस्',
  'button.edit': 'सम्पादन गर्नुहोस',
  'button.edit_log': 'लग सम्पादन गर्नुहोस ।',
  'button.finish': 'पुरा भयो ।',
  'button.forgot_your_password': 'पसवोर्ड बिर्सनुभयो ?',
  'button.i_already_have_assessment': 'मैले पहिल्यै मुल्यांकन गराइसके ।',
  'button.leave_anyway': 'यसलाई छोडिदिनुस ।',
  'button.login': 'लग इन',
  'button.no': 'होइन',
  'button.register': 'दर्ता गर्नुहोस ।',
  'button.send': 'पठाउनुहोस',
  'button.send_for_approval': 'स्वीकृतिको लागी पठाउनुहोस ।',
  'button.setup': 'मिलाउनु होस्',
  'button.setup_residential': 'आबासिय परियोजना तयार गर्नुहोस ।',
  'button.stay': 'येही रहनु होस् ।',
  'button.submit': 'बुझाउनु होस् ।',
  'button.update': 'अपडेट',
  'button.yes': 'हो',
  'errors.at_least_num_characters': 'कम्तिमा {length} लामो बर्ण आबस्यक',
  'errors.do_not_match': 'समान भएन',
  'errors.include_at_least_one_number': 'कम्तिमा एउटा नम्बर हुनु पर्छ ।',
  'errors.include_both_lower_and_upper_case': 'एसमा ठुलो अक्षर र सानो अक्षर हुनु पर्छ ।',
  'errors.invalid_phone_format': 'फोन नम्बरको शैली मिलेन ।',
  'errors.invalid_email_address': 'इमेल ठेगाना गलत भयो ।',
  'errors.required_field': 'आबस्यक खण्ड',
  'errors.must_be_at_least': 'कम्तिमा {min} बर्ण आबस्यक',
  'errors.must_be_no_more_than': 'बढीमा {max} बर्ण आबस्यक',
  'errors.must_be_an_integer': 'कुनै एउटा इन्तिजर हुनु पर्छ ',
  'errors.must_contain_at_least': 'कम्तिमा एउटा अंक अनिबार्य',
  'errors.must_include_at_least': 'यस्मा एउटा क्यापिटल लेटर हुनै पर्छ ।',
  'errors.must_be_one_of': 'यो मद्धे {enums} एक हुनु पर्छ ।',
  'errors.you_must_be_younger_than': 'अवार्डमा दर्ता हुनको लागि उमेर बर्ष महिना भन्दा कम हुनु पर्ने छ, एसबारे अवार्डको कर्मचारी इकाई संग कुरा गर्नुहोला ।',
  'errors.you_must_be_older_than': 'अवार्डमा दर्ता हुनको लागि उमेर बर्ष महिना भन्दा बढी हुनु पर्ने छ, एसबारे अवार्डको कर्मचारी इकाई संग कुरा गर्नुहोला ।',
  'errors.email_address_is_in_use_please_sign': 'यो इमेल ठेगान पहिलेनै प्रयोग भैसकेको छ, यदि तपाइँ अर्को तहमा दर्ता हुन चाहानुहुन्छ भने साइन इन गर्नुहोस ।',
  'errors.email_address_is_in_use': 'यो इमेल ठेगान पहिलेनै प्रयोग भैसकेको छ ।',
  'errors.sorry_we_already_have_this_email': "माफ गर्नुहोला, हामी  संग पहिलेनै यो इमेल ठेगाना बात खाता दर्ता भै सकेको छ, यदि तपाइँ अर्को तह सुरु गर्न चाहानुहुन्छ भने <a href='/'>आफ्नो खाता लग गर्नुहोस </a> अनि ' नया तह सुरु गर्नुहोस ' लाई सेलेक्ट गर्नुहोस । ",
  'wizard.authorising_contact': 'आधिकार प्राप्त ब्यक्तिको सम्पर्क नम्बर',
  'wizard.award_leader_contact': 'अवार्ड लिडरको सम्पर्क',
  'wizard.award_unit_details': 'अवार्ड इकाइको विस्तृत बिबरण',
  'wizard.contact_details': 'ठेगाना',
  'wizard.contacts': 'ठेगाना',
  'wizard.level': 'अवार्डको तह',
  'wizard.level_selection': 'अवार्ड छान्नुहोस्',
  'wizard.leader_details': 'लिडरको विस्तृत विवरण',
  'wizard.nominated_award_leader': 'मनोनित अवार्ड लिडर',
  'wizard.orb_account': 'ओआरबि खाता',
  'wizard.parent_consent': 'अभिभाबकको सहमति',
  'wizard.participant_details': 'सहभागीको विवरण',
  'wizard.profile': 'प्रोफाइल',
  'wizard.payment': 'भुक्तानि',
  'wizard.select_award_unit': 'अवार्ड इकाई छान्नुहोस ।',
  'wizard.unit_details': 'इकाईको विस्तृत विवरण',
  'wizard.welcome': 'स्वागतम',
  'wizard.your_details': 'तपाइको विवरण',
  'awardUnit.do_you_want_to_create': 'के तपाई नया अवार्ड इकाई सिर्जना गर्न चाहानुहुन्छ ?',
  'parent.you_can_download_the_consent_here': 'यदी तपाई संग छैन भने यहाबाट अभिभाबकको सहमतिको आबेदन फर्म डाउनलोड गर्न सक्नु हुन्छ, अभिभाबकलाई हस्ताक्षर गराएर पुन अवार्ड लिडरलाई  फर्काउनु होस । ',
  'footer.copyright': "&copy;  सर्बाधिकार The Duke of Edinburgh's International Award २०१७ ",
  'registration_participant.required_award_payment': 'अवार्ड भुक्तानी आबस्यक',
  'registration_participant.pay_online_here': 'अनलाइन भुक्तानीको लागि कारोबार आइडी यहाबाट प्राप्त गर्नुहोस ।',
  'dashboard.activity_log_time': '{hours}घण्टा  {minutes}मिनेट',
  'moduleTitle.award_completed': 'अवार्ड पुरा भएको छ',
  'notifications.award_approval_request_sent_to_leader': 'अवार्ड स्वीकृतिकोलागि गरिएको अनुरोध तपाइको लिडरलाई पठाईएको छ ।',
  'notifications.new_participant_event_has_been_completed': 'नया सहभागीको इभेन्ट पुरा भएको छ ।',
  'notifications.preparation_and_training_approval_sent': 'तयारि र तालिमको स्वीकृति पठाईएको छ ।',
  'notifications.reparation_and_training_completed': 'तयारि र तालिम पुरा भएको छ ।',
  'notifications.your_profile_photo_has_been_edited': 'तपाइको प्रोफाइल फोटो सम्पादन भयो ।',
  'notifications.your_profile_has_been_edited': 'तपाइको प्रोफाइल सम्पादन भयो ।',
  'notifications.new_level_has_started': 'नया तह सुरु भयो ।',
  'notifications.activity_has_been_edited': 'क्रियाकलाप सम्पादन गरियो ।',
  'notifications.you_have_been_logged_out': 'लगइन आउट',
  'notifications.logging_out': 'तपाईं लग आउट हुनु भयो ।',
  'label.you_can_send_award_to_leader': 'तपाइले आफ्नो अवार्ड स्वीकृतिको लागि अवार्ड लिडरलाई पठाउन सक्न्नु हुनेछ ।',
  'label.you_have_completed_all_sections_of_your_award': 'तपाइले अवार्डका सबै खण्ड पुरा गर्नु भएको  छ , अब तपाइले स्वीकृतिको लागि अवार्ड लिडरलाई पेस गर्न सक्नु हुने छ. साथै व्यक्तिगत टिप्पणी समेत राख्न सक्नु हुनेछ ।',
  'label.you_have_now_completed_your_award': 'तपाइले आफ्नो {level} अवार्ड पुरा गर्नु भएको छ , के तपाई अर्को तह सुरु गर्न चाहानुहुन्छ ?',
  'label.congratulation_your_award_has_been_approved': ' बधाई छ, तपाइको {level} तह स्वीकृत भयको छ !<br /> तपाइले चाहानुभयो भने अर्को तह पहिलानै सुरु गरि सक्नु भएको छ ।',
  'moduleTitle.settings': 'सेटिंगहरु',
  'moduleTitle.edit_activity': 'क्रियाकलाप सम्पदन गर्नुहोस ।',
  'moduleTitle.select_your_major_activity': 'मुख्य क्रियाकलाप छान्नुहोस् ।',
  'label.settings': 'सेटिंगहरु',
  'label.major_activity_means_that_you_will': 'प्रमुख क्रियाकलाप भन्नाले अन्य क्रियाकलाप भन्दा यो क्रियाकलापको लागि थप समय खर्चिनुपर्नेछ । गोल्ड र सिल्भरको लागि अतिरिक्त ६ महिना र ब्रोन्जको लागि मात्र थप  ३ महिनाको समय आबस्यक पर्दछ ।',
  'label.notifications': 'सुचनाहरु',
  'label.my_award': 'मेरो अवार्ड',
  'label.physical_recreation': 'शारीरिक मनोरञ्जन',
  'label.skill': 'सिप',
  'label.service': 'सेवा',
  'label.my_parent_will_complete_and_sign_form': 'मेरो अभिभावकले आवस्य प्रकिया पुरा गरि सहमति पत्रमा हस्ताक्षर गर्नु भयो ।',
  'label.please_print_it_tak_it_to_your_parent': 'कृपया एस लाई प्रिन्ट गर्नुहोस / तपाईं को आबिभावक संग कुरा गर्नुहोस र अवार्ड लिडर लाई बुझाउनु होस् ।',
  'label.change_password': 'पासवोर्ड परिवर्तन',
  'label.change_major_activity': 'मुख्य क्रियाकलाप परिबर्तन गर्नुहोस ,',
  'title.change_password': 'पासवोर्ड परिवर्तन',
  'label.old_again': 'पुरानो पासवोर्ड',
  'label.new_password': 'नया पास्वोर्ड',
  'label.new_password_again': 'पुन नया पासवोर्ड',
  'errors.passwords_dont_match': 'पासवोर्ड समान भएन',
  'errors.more_than': '{limit} भन्दा बढी',
  'button.parent_guardian_consent_pdf': 'अभिभाबकको सहमति.pdf',
  'button.send_award_for_approval': 'अवार्ड स्वीकृतिको लागि पठाउनुहोस ।',
  'button.send_report': 'गुनासो पठाउनुहोस ।',
  'button.terms_and_conditions': 'अन्तरास्ट्रिय मूल्य र मान्यताहरु',
  'button.privacy_policy': 'गोप्यताका नियमहरु ',
  'button.save': 'सुरक्षित राख्नुहोस ।',
  'button.start_new_level': 'नया तह सुरु गर्नुहोस ।',
  'button.change_password': 'पासवोर्ड',
  'button.edit_activity': 'क्रियाकलाप सम्पादन गर्नुहोस ।',
  'moduleTitle.file_upload': 'फाइल अपलोड गर्नुहोस ।',
  'label.add_file': 'फाइल राख्नुहोस । ',
  'label.description': 'विवरण',
  'label.waiting_for_office_sign_off': 'अवार्ड कार्यालयको साइन अफको पर्खाइमा ।',
  'notifications.file_has_been_uploaded': 'फाइल अपलोड भएको छ ।',
  'tabs.files': 'फाइलहरु',
  'button.upload': 'अपलोड',
  'button.upload_file': 'फाइल अपलोड गर्नुहोस ।',
  'button.add_file': 'फाइल राख्नुहोस ।',
  'button.this_activity_has_no_assessor': 'यो क्रियाकलाप को लागि निरीक्षक तय गरिएको छैन , अनुमोदनको लागि पठाउनु पूर्व निरीक्षकको विवरण उल्लेख गर्नुहोस ।',
  'label.i_want_to_register_my_award': 'म मेरो अवार्ड इकाईलाई स्वतन्त्र अवार्ड केन्द्रको रुपमा दर्ता गर्न चाहान्छु ।',
  'label.select_sub_operating_authority': 'सह संचालक छान्नुहोस् ।',
  'label.your_must_first_setup_some_activity': 'सर्बप्रथम केहि क्रियाकलाप तय गर्नुहोस ।',
  'label.you_cant_change_your_major_activity': 'तपाइँ आपनो मुख्य क्रियाकलाप परिबर्तन गर्न सक्नु हुन्न , तपाइको मुख्य क्रियाकलाप पहिलानै पुरा भैसकेको छ ।',
  'label.s_specific': "<b>S- Specific: तपाईंको लक्ष्य  व्यापक हुनु  हुँदैन </b> बरु सेटिङमा ; 'म भाइलिनमा राम्रो हुन चाहनुहुन्छ ,म भाइलिनमा F scale मा मास्टर गर्न चाहन्छु ', भन्न सक्नुहुन्छ' ।",
  'label.m_measurable': "<b>M-Measurable: तपाईंले आफ्नो लक्ष्य पूरा  गरेपछि बताउन सक्षम हुनुपर्छ </b> बरु आफ्नो लक्ष्य सेट, 'म समुदायको  मद्दत गर्न चाहन्छु  ' हप्ताको 'एक पटक भान्सा मा काम गर्ने मान्छेहरुलाई मदत गर्नेछु' भनि गर्न सक्नु हुनेछ  । जुन  लक्ष्य  हासिल गर्नु भयो भयन  परीक्षण गर्न  सकियोस ।",
  'label.a_achievable': "<b>A-Achievable: तपाईंको लक्ष्य त्यस्तो हुनुपर्छ जुन  तोकियको अवार्डको समयमा हासिल हुनुपर्छ </b> 'म गरिबी अन्त्य गर्न चाहन्छु' भन्ने अव्याबहारिक लक्ष भन्दा  ' कुनै  गाउँको गरीबि कम गर्न सहयोग रकम सन्कलन गर्नेछु  ।' भन्ने व्याबहारिक लक्ष निर्धारण गर्न सक्नुहुनेछ ।",
  'label.r_realistic': "<b>R-Realistic: यो मूलतः 'Achievable' जस्तै हो </b>  निस्चित समयमा प्राप्त गर्न सकिने व्याबहारिक लक्ष  हुनुपर्ने छ ।",
  'label.t_timely': "<b>T-Timely:  तपाईंसँग लक्ष साथमा सो लक्ष हासिल गर्ने समय पनि निस्चित गर्न जरुरी छ । </b> तपाईंको लक्ष्य यस्तो हुन सक्छ , 'म तीन महिना भित्र भाइलिनको  F scale मा  मास्टर गर्न चाहन्छु । '",
  'label.you_can_upload_here_any_files': 'अवार्ड लिडरलाई उपलब्ध गराउन चाहने सम्पूर्ण फाइल यहाँ अपलोड गर्न सक्नु हुने छ ।',
  'moduleTitle.login_change': 'लग इन परिवर्तन गर्नुहोस् ।',
  'notifications.adventurous_journey_modified': 'साहसिक यात्रा संसोधन भएको छ ।',
  'tabs.sections': 'खण्डहरु',
  'label.change_email': 'इमेल परिवर्तन',
  'title.change_email': 'इमेल परिवर्तन',
  'label.new_email': 'नया इमेल',
  'label.new_email_again': 'नया इमेल ठेगाना पुष्टि गर्नुहोस ।',
  'errors.emails_dont_match': 'इमेल ठेगाना समान भएन',
  'button.change_email': 'इमेल परिबर्तन',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'प्रकिया सहितको इमेल तपाइलाई पठाईसकीएको छ .।',
  'global.dofe_name': 'द ड्युक अफ इडीनबर्गस अवार्ड ।',
  'global.or': 'अथवा',
  'route.landing_page': 'अवतरण पृष्ठ',
  'route.dashboard': 'ड्यासबोर्ड',
  'moduleTitle.notifications': 'सुचनाहरु',
  'moduleTitle.no_notifications': 'सुचनाहरु छैनन् ।',
  'moduleTitle.new_notifications': 'नया सुचनाहरु',
  'moduleTitle.older_notifications': 'पुराना सुचनाहरु',
  'moduleTitle.user_guide': 'प्रयोगकर्ता पुस्तिका',
  'label.user_guide': 'प्रयोगकर्ता पुस्तिका',
  'notifications.your_password_has_been_changed': 'तपाइको पासवोर्ड परिवर्तन भएको छ ।',
  'label.country': 'देश',
  'label.on_your_smartphone': 'तपाइको स्मार्टफोनमा',
  'label.on_the_web': 'वेबमा ',
  'label.orb_online': 'ORB अनलाइन',
  'label.language': 'भाषा',
  'moduleTitle.participant_login': 'सहभागीको लागि लगइन',
  'label.for_ios': 'आइओएसको लागि ',
  'label.for_android': 'एन्ड्रोईडको लागि ',
  'button.login_as_award_staff': 'अवार्ड कर्मचारीको रुपमा लगइन गर्नुहोस ।',
  'errors.leader_doesnt_exist': 'लिडर देखिदैन ।',
  'global.loading': 'लोड भै रहेको छ ।',
  'moduleTitle.award_staff_login': 'अवार्ड स्टाफ लग इन',
  'formTitle.residential_project_details': 'आबासिय परियोजनाको विवरण',
  'label.you_can_also_download_participant': 'तपाईंहरु कुनै पनि बेला कुनै पनि ठाउँ बाट नया <strong> सहभागी यप  app</strong> डाउनलोड गर्न सक्नुहुन्छ ।',
  'label.you_can_also_download_leader': 'तपाईंहरु कुनै पनि बेला कुनै पनि ठाउँ बाट नया <strong> अवार्ड लिडर app</strong> डाउनलोड गर्न सक्नुहुन्छ ।',
  'notifications.this_role_is_not': 'तत्कालको लागि तपाइको भूमिका स्वीकार्य भएन ।',
  'notifications.residential_project_has_been_updated': 'आबासिय परियोजना परिस्कृत भयको छ ।',
  'tabs.participant': 'सहभागी',
  'tabs.award_staff': 'अवार्ड कर्मचारी',
  'moduleTitle.edit_residential_project': 'आबासिय परियोजना सम्पादन गर्नुहोस ।',
  'button.residential_project': 'आबासिय परियोजना सम्पादन गर्नुहोस ।',
  'notifications.your_login_email_has_been_changed': 'तपाइको लगइन इमेल परिबर्तन भएको छ ।',
  'meta.dofe_name': 'The Duke of Edinburgh’s Award',
  'notifications.unknown_role_leader': 'थाहा नभएको भूमिका -अवार्ड स्टाफको  लग इन प्रयोग गर्नुहोस ।',
  'notifications.unknown_role_participant': 'थाहा नभएको भूमिका - सहभागीको लग इन प्रयोग गर्नुहोस ।',
  'label.user_guide_web_participant': 'सहभागीका  लागि वेब  प्रयोग गर्ने निर्देशिका',
  'label.user_guide_app_participant': 'सहभागीका  लागि यप प्रयोग गर्ने निर्देशिका',
  'label.note_for_supervisor': 'निरीक्षकको लागि नोट',
  'label.before_submitting_your_aj': 'तपाइको यात्रा अवार्ड लिडरलाई पठाउनु पुर्ब तपाइको {role} बाट अनुमोदन गराउनु पर्ने छ , यदि तपाइँ चाहानुहुन्छ भने व्यक्तिगत टिप्पणी समेत राख्न सक्नु हुन्छ ।',
  'button.back_to_home': 'मुख्य पृष्ठमा फर्कनुहोस ।',
  'moduleTitle.assessor_approval': '{role} अनुमोदन',
  'label.this_aj_has_no_assessor': 'तपाइको साहसिक यात्राको लागि  कुनै भूमिका  {role} छैन, अनुमोदनको लागि पठाउनु पूर्व विस्तृत विवरण उल्लेख गर्नुहोस ।',
  'route.not_found': 'भेटिएन',
  'notifications.are_you_sure': 'साच्चै ?',
  'button.cancel': 'रद्ध',
  'label.add_document': 'डकुमेन्ट राख्नुहोस ।',
  'errors.there_are_currently_no_details_for_your': 'अहिले तपाइको को कुनै पनि विवरण प्राप्त भएको छैन, आफ्नो क्रियाकलाप मुल्यांकनको लागि पेस गर्नुपूर्व भर्न बाकि विवरण भर्नुहोस ।',
  'moduleTitle.missing_data': 'छुटेका डाटाहरु',
  'label.to_send_assessment_request': "एदी तपाईं लाई विधुतीय साधन द्वारा आफ्नु मुल्यांकन गराउन चाहनुहुन्छ भने कृपया यो {role}'s इमेल भर्नुस",
  'label.pending_changes': 'परिबर्तन हुने क्रममा छन',
  'label.some_fields_require': 'केहि भाग हरुमा तपाईं को ध्यान जानु आबस्यक छ .',
  'roles.assessor': 'निरीक्षक',
  'roles.supervisor': 'पर्यबेक्षक',
  'pageTitle.register_participant': 'सहभागीको रुपमा दर्ता गर्नुहोस .',
  'moduleTitle.revise_message': 'सन्देस सच्याउनुहोस ।',
  'moduleTitle.payment_for_level': '{awardLevel} का  लागि भुक्तानी',
  'moduleTitle.payment': 'सहभागी रजिस्ट्रेशन फि भुक्तानी',
  'moduleTitle.we_have_sent_you_payment_link': 'Payment Gateway का लागि हामीले तपाईं लाई लिंक पठाएका छौं /',
  'label.required_award_payment': 'आबस्यक अवार्ड भुक्तानी',
  'label.payment_fees': 'फि भुक्तानी',
  'label.payment_method': 'भुक्तानी तरिका ',
  'label.you_will_type_trans_id': 'तपाईं को  transaction ID टाइप गर्नको लागि अनुरोध गरिन्छ ',
  'label.any_level_previously': 'पहिल्यै सकिएको कुनै तह ',
  'label.registering_for_level': 'यो लेबल को लागि रजिस्टर',
  'notification.payment_link_expired': 'भुक्तानी लिंक को समय सकियो ',
  'button.pay': 'भुक्तानी',
  'label.registration_updated': 'तपाईं को रजिस्ट्रेशन अपडेट भैसक्यो अब तपाईं यो पेज बन्द गर्न सक्नुहुन्छ /',
  'label.award_leader_receive_payment': 'तपाईं को भुक्तानी को बारेमा तपाईं को अवार्ड लिडर ले जानकारी पाउनु हुनेछ /',
  'errors.end_date_after': 'सुरु मिति पछाडी अन्तिम मिति हुनुपर्छ ',
  'button.back': 'पछाडी ',
  'button.edit_info': 'जानकारी सम्पादन ',
  'moduleTitle.level_detail': 'लेबलको  विस्तृत विवरण ',
  'label.payment_methods': 'भुक्तानी तरिका ',
  'label.address': 'ठेगाना ',
  'note.review_filled_participant': 'कृपाया सहभागीले बुझाउनु भएको जानकारी हेर्नुहोस / एदी तपाईं ले बेठिक भेट्नु भएमा त्यस लाई सच्च्याउन सक्नुहुन्छ /',
  'moduleTitle.payment_successful': 'सहभागीको रजिस्ट्रेशन भुक्तानी सफल भएको छ /',
  'button.proceed_to_login': 'लग इन गर्नुहोस ',
  'label.add_additional_activity': 'अतिरिक्त क्रियाकलाप थप गर्नुहोस ',
  'moduleTitle.welcome_to_orb': 'Online Record Book मा स्वागत छ /',
  'empty_dashboard.not_approved': 'अवार्ड को समयमा तपाईं को रेकर्ड अगाडी बढाउन यो टुल ले सहयोग गर्छ / तर तपाईं को अवार्ड लिडर ले तपाईं को प्रोफाइल स्वीकार गर्नुभएको छैन / तपाईं को पहिलो क्रियाकलाप सुरु गर्नु अगाडी प्रोफाइल स्वीकार का लागि पर्खनुहोस् /',
  'empty_dashboard.approved_1': 'अवार्ड को समयमा तपाईं को अवार्ड को प्रगति रेकर्ड गर्न यो टुल ले सहयोग गर्छ /',
  'empty_dashboard.approved_2': 'पहिला तपाईं ले आफ्नो क्रियाकलाप तय गर्नुहोस / सुरु गर्नका लागि बायाँ तिर क्लिक गर्नुहोस / क्रियाकलाप तय गर्न तपाईंलाई केहि सहयोग चाहिन्छ भने तपाईं ले आफ्नो अवार्ड लिडर संग सोध्न सक्नुहुन्छ /',
  'label.discuss_activity_leader': 'एदी तपाईं ले एक भन्दा बढी क्रियाकलाप छनौट गर्दै हुनुहुन्छ भने कृपया तपाईं को अवार्ड लिडर संग सम्पर्क गर्नुहोला /',
  'label.cannot_add_activity': 'तपाईं बढीमा ३ ओटा क्रियाकलाप थप्न सक्नुहुन्छ / कृपया तपाईं को अवार्ड लिडर संग सम्पर्क गर्नुहोला /',
  'button.ok': 'हुन्छ ',
  'label.payment_was_canceled': 'प्रयोगकर्ता ले भुक्तानी रद्द गर्नुभएको छ /',
  'label.problem_with_payment': 'तपाईं को भुक्तानी प्रक्रियामा समस्या आएको छ / कृपया तपाईं को National Award Operator (NAO) संग सम्पर्क गर्नुहोस /',
  'pageTitle.register_leader': 'अवार्ड लिडर',
  'pageTitle.registration_complete': 'रजिस्ट्रेशन पुरा भयो ',
  'label.payment_link_expired_or_paid': 'तपाईं ले रजिस्ट्रेशन फी तिरी सक्नु भएको छ  अथवा तपाईं को भुक्तानी लिंकको समय सकी सकिएको छ /',
  'label.contact_nao_assistance': 'कुनै सहयोग चाहिएमा NAO  संग सम्पर्क गर्नुहोस /',
  'label.send_required_amount_to_your_award_leader': 'आबस्यक रकम आफ्नो युनिट को अवार्ड लिडर वा कोअर्डिनेटर लाई बुझाउनु होस् ',
  'label.fee_can_be_paid': 'VISA, Master Card or Credit Debit Cards बाट पनि तपाईं ले फी बुझाउन सक्नुहुन्छ /',
  'notifications.login_failed_right_tab': 'लग इन हुन सकेन / पुन हेर्नुहोस कि तपाईं ठिक ट्याब (Participant / Award Staff) मा हुनुहुन्छ /',
  'label.i_have_read_privacy_policy': 'मैले  गोपनीयता नीति पढेको छु र  सहमत छु /',
  'errors.invalid_date_format': 'मिति लेखिएको तरिका मिलेन ',
  'label.no_privacy_policy': 'कुनै पनि गोपनियेता नीति पाइएन / तपाईं सकियो बटन क्लिक गरेर आगाडी बढ्न सक्नुहुन्छ /',
  'label.status': 'स्थिति',
  'moduleTitle.attached_with_observation': 'अबलोकनका साथ संलग्न ',
  'moduleTitle.revise_message_rp': 'तपाईंको अवार्ड लिडर ले तपाईं को आवासीय परियोजना मुल्याकन गर्नुभएको छ /',
  'file.activity_section_summary': '{section}-खण्ड-सारांश',
  'label.download_section_summary': 'खण्ड-सारांश डाउनलोड गर्नुहोस ',
  'label.award_summary': 'अवार्ड सारांश',
  'btn.download_summary_for_assessor': 'निरीक्षकको लागि सारांश डाउनलोड गर्नुहोस ',
  'label.first_activity_started': 'पहिलो  क्रियाकलाप सुरु भयो ',
  'label.hours_completed_required': 'घण्टा पुरा भयो वा आबस्यक छ /',
  'label.weeks_completed_required': 'हप्ता  पुरा भयो वा आबस्यक छ /',
  back_to_home: 'सुरु मा फर्कनुहोस ',
  'label.activity_rejected_click': 'तपाईं को क्रियाकलाप  अवार्ड लिडर द्वारा अस्वीकृत गरिएको छ / क्लिक for␣',
  'button.more_information': 'अन्य जानकारी ',
  'label.attached_file': 'Attached फाइल ',
  'moduleTitle.journey_details': 'यात्रा को बिस्तृत विवरण ',
  'tabs.activity': 'क्रियाकलाप',
  'label.confirm_email': 'इमेल निश्चित गर्नुहोस ',
  'label.aj_rejected_click': 'तपाईं को अवार्ड लिडर ले तपाईं को यात्रा अस्वीकार गर्नुभएको छ ',
  'label.verifying_payment': 'भुक्तानी निश्चित गरिदै ',
  'button.finish_and_pay': 'सक्नुहोस र भुक्तानी गर्नुहोस ',
  'label.payment_not_successful_text': 'तपाईं  ले भुक्तानी गर्नुभएको छैन / तपाईं ले भुक्तानी गर्नेबेला भैसकेको छ /',
  'label.payment_not_completed': 'भुक्तानी पुरा भएको छैन ',
  'button.pay_now': 'अहिले भुक्तानी गर्नुहोस ',
  'label.registration_pending_parental_consent': 'तपाईं को अबिभाबक ले आनुमति दिई नसकेकोले तपाईं को रजिस्ट्रेसन रोकिएको छ ',
  'button.edit_observation': 'निरक्षण सम्पादन गर्नुहोस ',
  'moduleTitle.qualifying': 'योग्यता',
  'moduleTitle.practice': 'अभ्यास ',
  'label.first_log_entry': 'पहिलो  लग ',
  'label.first_log_entry_date': 'पहीलो लग मिति ',
  'label.last_log_entry': 'अन्तिम लग ',
  'label.last_log_entry_date': 'अन्तिम लग मिति ',
  'label.you_can_send_journey_report_for_approval': 'तपाईं को यात्रा रिपोर्ट  {journey}  प्रमाणीकरण को लागि पठाउन सक्नुहुन्छ',
  'button.edit_and_resend_report': 'सम्पादन गरेर रिपोर्ट पुन पठाउनु होस् ',
  'label.your_journey_is_complete': 'तपाईं को {journeyType} पुरा भएको छ ',
  'button.add_additional_journey': 'अन्य यात्रा थप्नुहोस ',
  'moduleTitle.edit_journey': 'यात्रा सम्पादन गर्नुहोस ',
  'notifications.assessment_sent': 'मुल्यांकन का लागि पठाइएको छ ',
  'notifications.file_is_too_big': 'फाइल अपलोड गर्न सकिएन / साएद यो ठुलो भएर होला /',
  'notifications.authorization_code_has_expired': '',
  'route.confirm_email': '',
  'label.assessor_needs_account': '',
  'label.company_name': '',
  'label.secondary_email_again': '',
  'label.how_many_years': '',
  'label.no_company_leave_empty': '',
  'label.secondary_phone_number': '',
  'label.secondary_phone_type': '',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': '',
  'label.you_have_finished_aj_now_send_to_approval': '',
  'label.your_experience': '',
  'label.your_qualification': '',
  'notifications.waiting_for_assessor_approval': '',
  'button.resend_assessment_request': '',
  'errors.emails_must_be_different': '',
  'moduleTitle.company_details': '',
  'notifications.already_resent_assessment_request': '',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': '',
  'wizard.assessor_details': '',
  'wizard.assessor_experience': '',
  'wizard.personal_details': '',
  'button.sign_off': '',
  'button.sign_off_dashed': '',
  'moduleTitle.sign_off': '',
  'label.certify_participant_met_reqs': '',
  'label.assessor_report': '',
  'label.content_update': '',
  'label.comment_on_participant_improvement': '',
  'note.edit_participant_review': '',
  'errors.min_age': '',
  'notifications.assessor_link_expired': '',
  'label.secondary_email': '',
  'moduleTitle.review_participant_info': '',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': '',
  'label.leader_name': '',
  'label.leader_phone': '',
  'label.leader_email': '',
  'moduleTitle.au_details': '',
  'label.au_name': '',
  'label.assessor_guidelines': '',
  'label.assessor_cond_req': '',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': '',
  'moduleTitle.participant_details': '',
  'label.participants_has_no_logs': '',
  'label.location_type': '',
  'label.activity_ready_for_signoff': '',
  'label.activities': '',
  'label.choose_how_you_want_to_login': '',
  'roles.leader': '',
  'roles.award_verifier': '',
  'roles.coordinator': '',
  'roles.aj_assessor': '',
  'roles.aj_supervisor': '',
  'roles.instructor': '',
  'roles.nao_staff': '',
  'roles.super_user': '',
  'roles.user': '',
  'roles.viewer': '',
  'roles.authorizing_contact': '',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': '',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': '',
  'label.if_you_have_questions_au': '',
  'label.we_will_send_you_an_email_leader': '',
  'moduleTitle.rejecting_assessor_invitation': '',
  'notifications.assessor_invitation_rejected': '',
  'moduleTitle.participants_list_is_empty': '',
  'label.note_from_participant': '',
  'label.you_can_send_aj_to_leader': '',
  'button.save_report': '',
  'label.this_activity_has_no_assessor': '',
  'label.activity_rejected_click_by_assessor': '',
  'button.reject': '',
  'button.reject_invitation': '',
  'label.reason': '',
  'label.accept_invitation_and_continue': '',
  'pageTitle.registration_reject': '',
  'errors.you_must_be_older_than_register_for_leader': '',
  'label.your_report_approve_now_send_to_leader_without_note': '',
  'button.stop_assessing_this_activity': '',
  'button.confirm': '',
  'moduleTitle.are_you_sure': '',
  'label.content_restore': '',
  'button.stop_editing': '',
  'notifications.activity_has_been_rejected': '',
  'notifications.aj_has_been_rejected': '',
  'notifications.rp_has_been_rejected': '',
  'moduleTitle.additional_files': '',
  'moduleTitle.no_additional_files': '',
  'moduleTitle.stop_assessing_section': '',
  'label.show_security_and_refund_policy': '',
  'moduleTitle.security_and_refund_policy': '',
  'label.fees_payment': '',
  'label.redund_policy': '',
  'label.security_policy': '',
  'label.leave_blank': '',
  'label.frequently_asked_questions': '',
  'label.language_selection_is_disabled_for_iac': '',
  'errors.min_nights_required': '',
  'label.completion_date': '',
  'label.you_are_offline': '',
  'errors.start_date_after_award_start': '',
  'label.participants': '',
  'label.marketing_from_iaf': '',
  'label.marketing_from_oa': '',
  'label.marketing_from_nao': '',
  'label.select_iac': '',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': '',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
